module.exports = __webpack_public_path__ + "img/xyk_logo.e4f6cb5f.png";